// @flow

import React, { type Node, useState } from 'react';
import questionIconSrc from './question-icon.svg';
import PagofacilTaxesModal from './pagofacil-taxes-modal';

export default function PagofacilTaxesInfo(): Node {
  const [modalStatus, setModalStatus] = useState('');
  const toggleModal = () => {
    setModalStatus('is-open');
  };

  const closeModal = () => {
    setModalStatus('');
  };

  return (
    <>
      <img src={questionIconSrc} alt="question icon" onClick={toggleModal} />
      <PagofacilTaxesModal status={modalStatus} closeModal={closeModal} />
    </>
  );
}
